import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const inputFileBadgeFn = /* @__PURE__ */ createRecipe('input-file-badge', {}, [])

const inputFileBadgeVariantMap = {}

const inputFileBadgeVariantKeys = Object.keys(inputFileBadgeVariantMap)

export const inputFileBadge = /* @__PURE__ */ Object.assign(memo(inputFileBadgeFn.recipeFn), {
  __recipe__: true,
  __name__: 'inputFileBadge',
  __getCompoundVariantCss__: inputFileBadgeFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: inputFileBadgeVariantKeys,
  variantMap: inputFileBadgeVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, inputFileBadgeVariantKeys)
  },
  getVariantProps: inputFileBadgeFn.getVariantProps,
})